import './article-attachments.scss';

/**
 * version    1.0
 * class      <type> (article attachments)
 * classdesc
 */
export class ArticleAttachments {}
